import React from 'react';
import PropTypes from 'prop-types';
import { Check, Sparkles } from 'lucide-react';
import {
  Display,
  Text,
  Stack,
} from '@/components/ui/index.js';
import styles from './CompleteStep.module.css';

/**
 * CompleteStep - Final success step
 * 
 * Features:
 * - Success animation with checkmark
 * - Completion message
 * - Start exploring CTA
 */
export function CompleteStep({ onStartExploring }) {
  return (
    <Stack direction="column" gap={8} align="center" className={styles.container}>
      {/* Success Icon */}
      <div className={styles.iconWrapper}>
        <div className={styles.iconGlow} />
        <div className={styles.iconBackground}>
          <Check size={48} className={styles.icon} />
        </div>
        <Sparkles size={24} className={styles.sparkle1} />
        <Sparkles size={16} className={styles.sparkle2} />
        <Sparkles size={20} className={styles.sparkle3} />
      </div>

      {/* Success Text */}
      <Stack direction="column" gap={4} align="center" className={styles.textSection}>
        <Display 
          size="xl" 
          weight="black" 
          color="primary" 
          align="center"
          shadow
        >
          You&apos;re all set!
        </Display>
        
        <Text 
          size="lg" 
          color="secondary" 
          align="center"
          leading="relaxed"
          className={styles.description}
        >
          Your profile is ready. Start discovering sports activities, 
          events, and athletes near you.
        </Text>
      </Stack>

      {/* CTA Button */}
      <button 
        type="button"
        onClick={onStartExploring}
        className={styles.ctaButton}
      >
        <span className={styles.ctaButtonText}>Start Exploring</span>
        <span className={styles.ctaButtonGlow} />
      </button>
    </Stack>
  );
}

CompleteStep.propTypes = {
  onStartExploring: PropTypes.func.isRequired,
};

export default CompleteStep;
